import React, { useState } from "react";

import Toggle from "react-toggle";

import Modal from "../../components/Modal";
import Button from "../../components/Button";
import FormInput from "../../components/FormInput";
import SelectCheckbox from "../../components/SelectCheckbox";
import Checkbox from "../../components/Checkbox";
import DriverLicenseScanner from "../../components/DriverLicenseScanner";

import CaretIcon from "../../icons/caret.png";
import Tick from "../../icons/rev_confirm.png";
import DeleteIcon from "../../icons/rev_delete.png";
import EYE from "../../icons/eye.png";

import { getLoginDetails } from "../../utils/storage";
import { STATES_LIST } from "../../utils/api";

import ImageUploading from "../../components/AddEditItems/ImageUpload";

const STATES = ["Florida", "Wisconsin", "Georgia"];

const PARTNER_TYPES = [
  {
    id: "YES",
    value: "YES",
  },
  {
    id: "NO",
    value: "NO",
  },
];
const COMPANY_TYPES = [
  {
    id: "BUYER",
    value: "Partner Buyer",
  },
  {
    id: "SELLER",
    value: "Partner Seller",
  },
  {
    id: "COLLECTOR",
    value: "Partner Collector",
  },
  {
    id: "SI",
    value: "Seller Individual",
  },
  {
    id: "VIEWER",
    value: "VIEWER",
  },
];

const normalizeInput = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (value.length > 0) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return `${currentValue.slice(0, 3)}-${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

const EntityAddEdit = ({
  item,
  onClose,
  onSave,
  type,
  onBack,
  shouldShowPriceMod,
  facilities,
  editType,
  setRemoveTabs,
  isNewCustomer,
}) => {
  const [companyName, setCompanyName] = useState(item.companyName);
  const [address, setAddress] = useState(item.address);
  const [address1, setAddress1] = useState(item.address1);
  const [city, setCity] = useState(item.city);
  const [state, setState] = useState(item.state);
  const [zipcode, setZipcode] = useState(item.zipcode);
  const [email, setEmail] = useState(item.email);
  const [phone, setPhone] = useState(normalizeInput(item.phone || ""));
  const [firstName, setFirstName] = useState(item.firstName);
  const [lastName, setLastName] = useState(item.lastName);
  const [userEmail, setUserEmail] = useState(
    isNewCustomer ? item.userEmail : item.email
  );

  const [priceMod, setPriceMod] = useState(item.priceMod);
  const [businessLicense, setBusinessLicense] = useState(item.businessLicense);
  const [ein, setEin] = useState(item.ein);
  const [driversLicense, setDriversLicense] = useState(item.driversLicense);

  const [oldPassword, setOldPassword] = useState(item.oldPassword);
  const [newPassword, setNewPassword] = useState(item.newPassword);
  const [confirmPassword, setConfirmPassword] = useState(item.confirmPassword);

  const [seeOldPassword, setSeeOldPassword] = useState(false);
  const [seeNewPassword, setSeeNewPassword] = useState(false);
  const [seeConfirmPassword, setSeeConfirmPassword] = useState(false);

  const [sameUserEmail, setSameUserEmail] = useState(false);

  const hideAbcPricing = true;

  const [image, setImage] = useState(null);

  const [metalLicense, setMetalLicense] = useState(item.metalLicense);

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [showScanner, setShowScanner] = useState(false);

  const [validations, setValidations] = useState({});
  const [isPriceModifierPercantage, setIsPriceModifierPercantage] = useState(
    item.groupModifierIsPercentage
  );
  const [modifierInputValue, setModifierInputValue] = useState(
    item.groupModifier || ""
  );
  const validateFields = () => {
    const updatedValidations = { ...validations };

    // Company Name: minimum 3 characters
    updatedValidations.companyName = companyName && companyName.trim().length >= 3;
    // Email validation: must be present and in valid format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    updatedValidations.email = email && email.trim() && emailRegex.test(email.trim());
    // User Email validation: must be present and in valid format (if required)
    updatedValidations.userEmail = isNewCustomer 
      ? (userEmail && userEmail.trim() && emailRegex.test(userEmail.trim()))
      : (userEmail && userEmail.trim() && emailRegex.test(userEmail.trim()));
    updatedValidations.address = address;
    // updatedValidations.address1 = address1;
    updatedValidations.phone = phone;
    updatedValidations.city = city;
    updatedValidations.state = state;
    updatedValidations.zipcode = zipcode;
    // First Name: minimum 2 characters
    updatedValidations.firstName = firstName && firstName.trim().length >= 2;
    // Last Name: minimum 2 characters
    updatedValidations.lastName = lastName && lastName.trim().length >= 2;
    // Driver License: mandatory
    updatedValidations.driversLicense = driversLicense;

    updatedValidations.oldPassword = oldPassword;
    updatedValidations.newPassword = newPassword;
    updatedValidations.confirmPassword = confirmPassword;

    setValidations(updatedValidations);
    return updatedValidations;
  };

  return (
    // <Modal>
    <div className="mt-8">
      <div 
        className="fs-24 fw-bolder mb-40 c-gray"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
      >
        <span>FILL THE REQUIRED DETAILS</span>
        <Button
          type="secondary"
          onClick={() => setShowScanner(true)}
          className="rounded-pill"
          style={{ 
            whiteSpace: 'nowrap', 
            padding: '4px 8px', 
            fontSize: '11px',
            height: '28px',
            lineHeight: '20px',
            backgroundColor: '#4a90e2',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            marginLeft: '20px',
            minWidth: 'auto',
            width: 'auto'
          }}
        >
          📷 Scan
        </Button>
      </div>

      <div className="flex flex-between flex-middle mb-40 flex-wrap">
        <FormInput
          placeholder="Company Name"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setCompanyName(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={companyName}
          hasError={hasSubmitted && !validations.companyName}
          errorMessage={hasSubmitted && !validations.companyName && companyName ? 'Company Name must be at least 3 characters' : undefined}
        />
        <FormInput
          placeholder="First Name"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setFirstName(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={firstName}
          hasError={hasSubmitted && !validations.firstName}
          errorMessage={hasSubmitted && !validations.firstName && firstName ? 'First Name must be at least 2 characters' : undefined}
        />
        <FormInput
          placeholder="Last Name"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setLastName(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={lastName}
          hasError={hasSubmitted && !validations.lastName}
          errorMessage={hasSubmitted && !validations.lastName && lastName ? 'Last Name must be at least 2 characters' : undefined}
        />
        <FormInput
          placeholder="Company Email"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            if (!isNewCustomer && (item.email || "").length > 0) return;
            setEmail(e.target.value);
            if (!isNewCustomer && (item.email || "").length <= 0) {
              setUserEmail(e.target.value);
            }
          }}
          className="mr-40 wt-33p"
          value={email}
          hasError={hasSubmitted && !validations.email}
          errorMessage={hasSubmitted && !validations.email && email ? 'Please enter a valid email address' : undefined}
        />
        <div className="mr-40 wt-33p">
          <FormInput
            placeholder="Admin/User Email"
            isMandatory={isNewCustomer}
            inputClassName="bg-blue rounded-pill"
            readOnly={!isNewCustomer}
            onChange={(e) => {
              if (!isNewCustomer) return;
              setUserEmail(e.target.value);
            }}
            // className="mr-40 wt-33p"
            value={userEmail}
            hasError={hasSubmitted && !validations.userEmail}
            errorMessage={hasSubmitted && !validations.userEmail && userEmail ? 'Please enter a valid email address' : undefined}
          />
          {isNewCustomer && (
            <Checkbox
              isSelected={sameUserEmail}
              label="Same as Company Email"
              labelClassName="fs-12"
              onClick={() => {
                setSameUserEmail(!sameUserEmail);
                setUserEmail(!sameUserEmail ? email : "");
              }}
            />
          )}
        </div>
        <FormInput
          placeholder="Phone"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setPhone(normalizeInput(e.target.value || ""));
          }}
          className="mr-40 wt-33p"
          value={phone}
          hasError={hasSubmitted && !validations.phone}
        />
      </div>
      <div className="flex flex-between flex-middle mb-40 flex-wrap">
        <FormInput
          placeholder="Company Address 1"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setAddress(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={address}
          hasError={hasSubmitted && !validations.address}
        />
        <FormInput
          placeholder="Company Address 2"
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setAddress1(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={address1}
          // hasError={hasSubmitted && !validations.address1}
        />
        <FormInput
          placeholder="Company City"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            setCity(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={city}
          hasError={hasSubmitted && !validations.city}
        />
        <div className=" mr-40 wt-33p">
          <div className="c-gray fs-14 mb-4">
            Company State <span className="c-error">*</span>
          </div>
          <select
            name="type"
            className="select font-primary fs-14 fw-bolder"
            value={state}
            onChange={(e) => setState(e.target.value)}
          >
            <option value={""}>Select State</option>
            {(STATES_LIST || []).map((state) => {
              return <option value={state}>{state}</option>;
            })}
          </select>
          {hasSubmitted && !validations.state && (
            <div className="fs-10 c-error fw-bold p-absolute">
              Please select valid state
            </div>
          )}
        </div>
        <FormInput
          placeholder="Company Zipcode"
          isMandatory={true}
          inputClassName="bg-blue rounded-pill"
          onChange={(e) => {
            if (isNaN(e.target.value)) {
              return;
            }
            setZipcode(e.target.value);
          }}
          className="mr-40 wt-33p"
          value={(zipcode || "").replace(/[^\d]/g, "")}
          hasError={hasSubmitted && !validations.zipcode}
        />
        <div className="mr-40 mb-20 wt-33p p-relative"></div>

        {!hideAbcPricing && shouldShowPriceMod && (
          <div className="wt-33p mr-40 p-relative t--8">
            <div className="fs-14 mb-4 fw-bold mt-20">Is ABC Pricing</div>
            <Toggle
              className="bg-theme"
              onChange={(e) => {
                setPriceMod(e.target.checked);
              }}
              checked={priceMod}
            />
          </div>
        )}

        <div className="flex flex-middle flex-between wt-100p">
          <FormInput
            className="mr-40 mb-20 wt-33p"
            placeholder="Business License"
            inputClassName="bg-blue rounded-pill"
            onChange={(e) => {
              setBusinessLicense(e.target.value);
            }}
            value={businessLicense}
          />
          <FormInput
            className="mr-40 mb-20 wt-33p"
            placeholder="EIN"
            inputClassName="bg-blue rounded-pill"
            onChange={(e) => {
              setEin(e.target.value);
            }}
            value={ein}
          />
          <FormInput
            className="mr-40 mb-20 wt-33p"
            placeholder="Driver License"
            isMandatory={true}
            inputClassName="bg-blue rounded-pill"
            onChange={(e) => {
              setDriversLicense(e.target.value);
            }}
            value={driversLicense}
            hasError={hasSubmitted && !validations.driversLicense}
          />
        </div>

        <div className="flex flex-middle  flex-between wt-100p">
          {!isNewCustomer ? (
            <div className="mr-40 mb-20 wt-33p p-relative">
              <FormInput
                type={seeOldPassword ? "text" : "password"}
                isMandatory={true}
                placeholder="Current Password"
                inputClassName="bg-blue rounded-pill"
                onChange={(e) => {
                  setOldPassword(e.target.value);
                }}
                value={oldPassword}
              />
              <img
                src={EYE}
                className="wt-25 p-absolute  r-4 t-26 c-pointer"
                onClick={(e) => {
                  setSeeOldPassword(!seeOldPassword);
                }}
              />
            </div>
          ) : null}

          <div className="mr-40 mb-20 wt-33p p-relative">
            <FormInput
              type={seeNewPassword ? "text" : "password"}
              isMandatory={true}
              // className="mr-40 mb-20 wt-33p"
              placeholder="New Password"
              inputClassName="bg-blue rounded-pill"
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
              value={newPassword}
            />
            <img
              src={EYE}
              className="wt-25 p-absolute  r-4 t-26 c-pointer"
              onClick={(e) => {
                setSeeNewPassword(!seeNewPassword);
              }}
            />
          </div>

          <div className="mr-40 mb-20 wt-33p p-relative">
            <FormInput
              type={seeConfirmPassword ? "text" : "password"}
              isMandatory={true}
              // className="mr-40 mb-20 wt-33p"
              placeholder="Confirm Password"
              inputClassName="bg-blue rounded-pill"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              value={confirmPassword}
            />
            <img
              src={EYE}
              className="wt-25 p-absolute  r-4 t-26 c-pointer"
              onClick={(e) => {
                setSeeConfirmPassword(!seeConfirmPassword);
              }}
            />
          </div>

          {isNewCustomer && (
            <div className="mr-40 mb-20 wt-33p p-relative"></div>
          )}
        </div>

        <div className="wt-33p mr-40 p-relative"></div>
        <div className="wt-33p mr-40 p-relative"></div>
        <div className="wt-33p mr-40 p-relative"></div>
      </div>
      <div className="flex flex-middle flex-right">
        <Button
          className="flex flex-middle mr-20 bg-red"
          type="modalCancel"
          onClick={() => {
            setRemoveTabs(false);
            onClose();
          }}
        >
          {/*<img src={DeleteIcon} className="wt-20 ht-20 mr-4"/>*/}
          <span>CANCEL</span>
        </Button>

        <Button
          type="modalSave"
          onClick={() => {
            // setRemoveTabs(false)
            setHasSubmitted(true);
            const updatedValidations = validateFields();
            
            const isFormValid =
              updatedValidations.companyName &&
              updatedValidations.address &&
              updatedValidations.userEmail &&
              updatedValidations.city &&
              updatedValidations.state &&
              updatedValidations.zipcode &&
              updatedValidations.firstName &&
              updatedValidations.lastName &&
              updatedValidations.email &&
              updatedValidations.driversLicense;

            if (!isFormValid) {
              // Scroll to first error field
              setTimeout(() => {
                const firstErrorField = document.querySelector('.forminput-wrap.has-error');
                if (firstErrorField) {
                  firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }, 100);
              return; // Prevent API call
            }

            const dataParam = {
              companyName,
              address,
              address1,
              phone,
              city,
              state,
              zipcode,
              email,
              userEmail,
              firstName,
              lastName,
              newPassword,
              confirmPassword,
              driversLicense,
              businessLicense,
              ein,
              companyId: item.companyId,
              companyLogo: item.companyLogo,
              priceMod: shouldShowPriceMod ? priceMod : undefined,
              groupModifierIsPercentage: isPriceModifierPercantage,
              groupModifier: modifierInputValue,
            };

            if (!isNewCustomer) {
              dataParam["oldPassword"] = oldPassword;
              dataParam["oldEmail"] = getLoginDetails().email || "";
            }
            onSave(
              dataParam,
              image ? image[0] : null,
              metalLicense ? metalLicense[0] : null
            );
          }}
        >
          {/* {type === 'add' ? 'Add' : 'Edit'} item */}
          <img src={Tick} className="wt-20 ht-20 mr-4" />
          <span>SAVE</span>
        </Button>
      </div>

      {showScanner && (
        <DriverLicenseScanner
          onScanComplete={(parsedData) => {
            // Auto-fill form fields from scanned data
            if (parsedData.firstName) {
              setFirstName(parsedData.firstName);
            }
            if (parsedData.lastName) {
              setLastName(parsedData.lastName);
            }
            if (parsedData.driversLicense) {
              console.log('Setting driver license:', parsedData.driversLicense);
              setDriversLicense(parsedData.driversLicense);
            } else {
              console.warn('No driver license number found in parsed data:', parsedData);
            }
            if (parsedData.address) {
              setAddress(parsedData.address);
            }
            if (parsedData.city) {
              setCity(parsedData.city);
            }
            if (parsedData.state) {
              // State abbreviation to full name mapping
              const stateAbbrMap = {
                'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
                'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
                'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
                'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
                'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
                'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
                'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
                'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
                'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
                'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
                'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
                'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
                'WI': 'Wisconsin', 'WY': 'Wyoming'
              };
              
              const stateValue = parsedData.state.toUpperCase().trim();
              // Check if it's already in STATES_LIST format
              let finalState = STATES_LIST.find(s => s.toUpperCase() === stateValue || s === parsedData.state);
              
              // If not found, try abbreviation mapping
              if (!finalState && stateAbbrMap[stateValue]) {
                finalState = stateAbbrMap[stateValue];
              }
              
              // If still not found, try to find by first 2 letters
              if (!finalState) {
                finalState = STATES_LIST.find(s => s.toUpperCase().substring(0, 2) === stateValue);
              }
              
              if (finalState) {
                setState(finalState);
              } else {
                // Fallback: use the value as-is
                setState(stateValue);
              }
            }
            if (parsedData.zipcode) {
              setZipcode(parsedData.zipcode);
            }
            setShowScanner(false);
          }}
          onClose={() => setShowScanner(false)}
        />
      )}
    </div>
    // </Modal>
  );
};

export default EntityAddEdit;
